/**
 * @desc list
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.AllocationMasterParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/allocation/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
